import React, { useEffect, useRef, useState } from "react";
import VonageSidebar from "./VonageSidebar";

export const focusedVideoframeOptions = {
    width: "98%",
    height: "calc(97% / 5)",
    insertMode: "append",
    showControls: false,
  };
  
export default function VonageFocusedView(props) {

    return (<div id="vonage-focused-view" style={{ display:(props.layoutMode == "focused" ? "block": "none") }}>
        <VonageSidebar {...props}  />
        <div ref={(r) => props.setMyStreamRef(r)} style={{display:(props.publisher && props.publisher.stream && !props.screenshareStream ? "block": "none")}} id="vonage-my-stream" style={{height:props.streams.length == 0 ? "99%":null, width:props.streams.length == 0 ? "99%":null}}></div>
        <div id="vonage-mainview"></div>
    </div>)
}